import Swal from 'sweetalert2'
import axios from 'axios'
import apiConnect from '../../../api/apiConnect'

export async function handleRenameDevice(row, trigger, setTrigger) {
    Swal.fire({
        title: 'Rename Device',
        input: 'text',
        inputLabel: 'Device Name : ' + row?.name,
        inputPlaceholder: 'Enter new device name',
        showCancelButton: true,
        confirmButtonText: 'Rename',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => {
            if (!value) {
                return 'You need to write something!'
            }
        },
    }).then(async (result) => {
        if (result.isConfirmed) {
            // Sweet alert loading
            Swal.fire({
                title: 'Renaming device...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            })
            const payload = {
                deviceId: row.device_id,
                deviceNameNew: result.value,
            }

            try {
                const response = await apiConnect.post('/v1/devices/rename-device', payload)
                Swal.fire({
                    icon: 'success',
                    title: 'Rename device successfully!',
                }).then(() => {
                    setTrigger(!trigger)
                })
            } catch (error) {
                console.error('Error fetching data:', error)
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                })
            }
        }
    })
}

